import React from 'react';

import { useAccountActions } from './AccountContext';
import PageSectionTitleWithActions from '../../Shared/UI/PageSectionTitleWithActions/components/PageSectionTitleWithActions';
import Button from '../../Shared/UI/Button/components/Button';
import EditPencilIcon from '../../Shared/UI/EditPencilIcon/components/EditPencilIcon';

const EmailPageSectionTitle = () => {
  const { openEmailUpdateModal } = useAccountActions();

  return (
    <PageSectionTitleWithActions
      text="Email Address"
      actions={
        <Button
          variant="ghost"
          icon={<EditPencilIcon />}
          iconOnly
          aria-label="Edit Email"
          onClick={() => {
            openEmailUpdateModal();
          }}
        />
      }
    />
  );
};

export default EmailPageSectionTitle;